import { BUY_TC, TRANSACTION_CHECKOUT, BALANCE_CHECK, IS_BUY_NFT, IS_KYC_MODEL, CLEAR_REDUX } from "./../actionTypes";

const initialState = {
    buyTc: false,
    transactionCheckout: false,
    balanceCheckout: false,
    isBuyNft: false,
    isKyc: false
}

export const buyTcReducer = (state = initialState, action) => {
    switch (action.type) {
        case BUY_TC:
            return {
                ...state,
                buyTc: action.payload
            };
        case TRANSACTION_CHECKOUT:
            return {
                ...state,
                transactionCheckout: action.payload
            };
        case BALANCE_CHECK:
            return {
                ...state,
                balanceCheckout: action.payload
            };
        case IS_BUY_NFT:
            return {
                ...state,
                isBuyNft: action.payload
            };
        case IS_KYC_MODEL:
            return {
                ...state,
                isKyc: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}